import { Fragment } from 'react'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './TopBar.module.scss'
import { ChevronRightSmall } from 'blaze-ui/icons'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

type V4Step = 'gettingStarted' | 'strategy' | 'campaign' | 'content' | 'finishingUp'

interface Props {
  highlightStep: V4Step
  leftSide?: boolean
  withScoreCard?: boolean
}

const V4_STEPS: { key: V4Step; label: string }[] = [
  { key: 'gettingStarted', label: 'Getting started' },
  { key: 'strategy', label: 'Strategy' },
  { key: 'campaign', label: 'Campaign' },
  { key: 'content', label: 'Content' },
  { key: 'finishingUp', label: 'Finishing up' },
]

export const TopBar = ({ highlightStep, leftSide = false, withScoreCard = false }: Props) => {
  const { isMobile } = useResponsiveDesign()

  if (isMobile) return null

  return (
    <div className={cx(Styles.container, { [Styles.leftSide]: leftSide, [Styles.withScoreCard]: withScoreCard })}>
      {V4_STEPS.map((step, index) => (
        <Fragment key={step.key}>
          {index > 0 && <ChevronRightSmall size={12} color="var(--dark-40)" />}
          <Text variant="placeholder" color={highlightStep === step.key ? 'var(--dark-90)' : 'var(--dark-40)'}>
            {step.label}
          </Text>
        </Fragment>
      ))}
    </div>
  )
}
